import axios from "axios";
import { createContext, useContext, useReducer } from "react";


const NotificationContext = createContext();

const serverUrl = 'https://osdevhub.com/homify_backend';

const initialState = {
    notificationData : [],
    notificationIsLoading : false,
    notificationErrorMessage : null
}

function reducer(state, action){
    switch (action.type) {
        case 'loading':
            return {
                ...state,
                notificationIsLoading : true
            }

        case 'notificationError':
            return{
                ...state,
                notificationErrorMessage: action.payload,
                notificationIsLoading : false,
            }
        case 'postNotification':
            return{
                ...state,
                notificationIsLoading : false,
            }

        case 'getNotifications':
            return{
                ...state,
                notificationIsLoading : false,
                notificationData: action.payload,
            }
        case 'markAsRead':
            return{
             ...state,
                notificationIsLoading : false,
            }
        case 'notificationDeleted':
            return{
             ...state,
                notificationIsLoading : false,
            }
    
        default:
            break;
    }
}

function NotificationProvider({children}){
    const [{notificationData, notificationIsLoading, notificationErrorMessage}, dispatch] = useReducer(reducer, initialState);

       async function markAsRead(id, data) {
            dispatch({ type: 'loading' });
            try {
                const response = await axios.patch(`${serverUrl}/api/notification-status/markasread/${id}`, data, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });
              if(response.data.message === "Notification marked as read successfully") {
                dispatch({
                  type: 'markAsRead',
                })
              }
            } catch (error) {
              dispatch({
                type: 'notificationError',
                payload: error.response?.data?.message || error.message || 'Error fetching notification'
            });

            console.error(error);
              
            }
      
          }
       async function deleteNotification(id, data) {
            dispatch({ type: 'loading' });
            try {
                const response = await axios.patch(`${serverUrl}/api/notification-status/delete/${id}`, data, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });
              if(response.data.message === "Notification deleted successfully") {
                dispatch({
                  type: 'notificationDeleted',
                })
              }
            } catch (error) {
              dispatch({
                type: 'notificationError',
                payload: error.response?.data?.message || error.message || 'Error fetching notification'
            });

            console.error(error);
              
            }
      
          }

           async function getAllNotifications() {
            dispatch({
                type:'loading'
            })
            try {
                const response = await axios.get(serverUrl + '/api/notifications');
                if (response.data.message === 'Notifications retrieved successfully') {
                    dispatch({
                        type: 'getNotifications',
                        payload: response.data.data
                    })
                }
            } catch (error) {
                dispatch({
                    type: 'notificationError',
                    payload: 'there is an error'
                })
                console.error(error);
                
            }
        } 

              async function getNotificationForUser(user_id) {
                    dispatch({ type: 'loading' });
                
                    try {
                        const response = await axios.get(`${serverUrl}/api/notifications/${user_id}`);
                
                        if (response.data.message === 'Notifications retrieved successfully') {
                          dispatch({
                        type: 'getNotifications',
                        payload: response.data.data
                    })
                        }
                    } catch (error) {
                        dispatch({
                            type: 'notificationError',
                            payload: 'there is an error'
                        })
                        console.error(error);
                
            }
                }

            async function postNotification(notifyData) {
            dispatch({ type: 'loading' });
        
            try {
                const response = await axios.post(`${serverUrl}/api/notification`, notifyData);
        
                if (response.data.message === 'Notification added successfully') {
                    dispatch({
                        type: 'postNotification',
                    });
                }
            } catch (error) {
                dispatch({
                    type: 'notificationError',
                    payload: 'Error uploading notification'
                });
            }
        }

    return <NotificationContext.Provider value={{
    notificationData, 
    notificationIsLoading, 
    notificationErrorMessage,
    postNotification,
    getAllNotifications,
    getNotificationForUser,
    markAsRead,
    deleteNotification
    }}>
        {children}
    </NotificationContext.Provider>
} 

function useNotification(){
    const context = useContext(NotificationContext)
    if (context === 'undefined') {
        throw new Error("You are using it outside the notification context");
    }
    return context
}

export {NotificationProvider, useNotification}